<template>
<div v-if="!clientUserAgent" id="pageTable" class="my-trucks">
    <v-container grid-list-xl fluid paddingZero>
        <v-layout row wrap style="margin-bottom:60px;">
            <v-flex lg12 pb-0>
                <v-card>
                    <v-toolbar card color="white">
                        <v-toolbar-title>
                            <h3>Search For Posted Trucks</h3>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <breadcrumbs :items="breadcrumbs" divider=">"></breadcrumbs>
                    <v-divider></v-divider>
                    <v-tabs slider-color="orange" @change="onTabChange">
                        <v-flex lg12>
                            <v-tab ripple> City Search </v-tab>
                            <v-tab ripple> Map Search </v-tab>
                        </v-flex>
                        <v-tab-item>
                            <v-card>
                                <v-card-text class="customPanel">
                                    <v-card>
                                        <template>
                                            <v-form @submit.prevent="submitCitySearchForm('citySearchForm')" data-vv-scope="citySearchForm">
                                                <v-container grid-list-xl fluid>
                                                    <v-layout row wrap>
                                                        <v-flex md8 xs12>
                                                            <div class="d-flex">
                                                                <v-text-field label="Origin" placeholder="Anywhere" autocomplete="off" v-validate="{origin_address: [hidden_city_origin_address]}" v-model="form.citySearch.origin_address" :error-messages="errors.collect('citySearchForm.city_origin_address')" id="city_origin_address" data-vv-name="city_origin_address" v-on:keyup="clearCitySearchAddressBar" data-vv-as="Origin Address">
                                                                </v-text-field>
                                                                <input :type="'hidden'" v-model="hidden_city_origin_address" ref="hidden_city_origin_address" data-vv-name="hidden_city_origin_address" />
                                                                    </div>
                                                        </v-flex>
                                                        <v-flex md4 xs12>
                                                            <div class="d-flex">
                                                                <v-combobox v-model="form.citySearch.origin_radius" :return-object="false" :items="utils.radiuslist" item-text="name" item-value="id" label="Radius in miles" v-validate="{numeric_radius: 'form.citySearchForm.origin_radius'}" :error-messages="errors.collect('citySearchForm.city_origin_radius')" id="city_origin_radius" data-vv-name="city_origin_radius" data-vv-as="Radius" placeholder="Radius" @keyup="onOriginRadiusChange"></v-combobox>
                                                            </div>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex md8 xs12>
                                                            <div class="d-flex">
                                                                <v-text-field :class="form.citySearch.destination_cities.length ? 'white-placeholder': ''" label="Destination" autocomplete="off" placeholder="Anywhere" v-model="form.citySearch.dest_address" :error-messages="errors.collect('citySearchForm.city_dest_address')" v-validate="{city_dest_address:true}" id="city_dest_address" data-vv-name="city_dest_address" data-vv-as="Destination Address">
                                                                </v-text-field>
                                                                <input :type="'hidden'" v-model="hidden_city_dest_address" ref="hidden_city_dest_address" data-vv-name="hidden_city_dest_address" />
                                                                    </div>
                                                                <div v-if="form.citySearch.destination_cities.length" :class="!errors.collect('citySearchForm.city_dest_address').length ? 'customChip' : ''">
                                                                    <v-chip @input="cityDestChipChange(index)" close v-for="(item, index) in form.citySearch.destination_cities" v-bind:key="index">
                                                                        {{item.dest_city !== '' ? item.dest_city + ',&nbsp;' + item.state_code : item.state_name}}
                                                                    </v-chip>
                                                                </div>
                                                        </v-flex>
                                                        <v-flex md4 xs12>
                                                            <div class="d-flex">
                                                                <v-combobox v-model="form.citySearch.dest_radius" :return-object="false" :items="utils.radiuslist" item-text="name" item-value="id" label="Radius in miles" v-validate="{numeric_radius: 'form.citySearchForm.city_dest_radius'}" :error-messages="errors.collect('citySearchForm.city_dest_radius')" id="city_dest_radius" data-vv-name="city_dest_radius" data-vv-as="Radius" placeholder="Radius" @keyup="onDestRadiusChange"></v-combobox>
                                                            </div>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex lg4 md4 xs12>
                                                            <v-menu ref="city_picker_available_date" lazy :close-on-content-click="false" v-model="form.citySearch.picker_available_date" transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px" :return-value.sync="form.citySearch.available_date">
                                                                <v-text-field class="custom-picker-text" id="available_date" v-validate="'required'" data-vv-name="available_date" data-vv-as="Available Date" :error-messages="errors.collect('citySearchForm.available_date')" slot="activator" label="Available Date *" :value="displayDate(form.citySearch.available_date)" prepend-icon="event" readonly></v-text-field>
                                                                <v-date-picker :min="minDate" v-model="form.citySearch.available_date" no-title scrollable @input="changePickerDate('available'); $refs.city_picker_available_date.save(form.citySearch.available_date)">
                                                                </v-date-picker>
                                                            </v-menu>
                                                        </v-flex>
                                                        <v-flex lg4 md4 xs12>
                                                            <div class="d-flex">
                                                                <v-autocomplete class="auotchoice" v-validate="{required:'citySearchForm.equipment_types'}" :items="citySearch_equipment_types" :error-messages="errors.collect('citySearchForm.equipment_types')" data-vv-name="equipment_types" data-vv-rules="equipment_types" v-model="citySearch_equipment_type_id_list" required data-vv-as="Equipment Types" item-text="name" item-value="code" label="Equipment Types *" multiple v-on:change="onEquipmentChange('citySearch',$event)"></v-autocomplete>
                                                            </div>
                                                        </v-flex>
                                                        <v-flex lg4 md4 xs12>
                                                            <div class="d-flex">
                                                                <v-select class="custom_dropdown" :items="truck_size_arr" :error-messages="errors.collect('load_size')" data-vv-name="load_size" v-model="form.citySearch.load_size" required data-vv-as="Load Size" item-text="name" item-value="id" label="Load Size">
                                                                </v-select>
                                                            </div>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                                <div class="form-btn text-xs-right">
                                                    <v-btn type="submit" color="green darken- white--text">
                                                        <v-icon>search</v-icon> Find Trucks
                                                    </v-btn>
                                                    <a href="#" id="scrollTopCitySearchTable" v-scroll-to="{'el':'#citySearchTable','offset':-mapSearchScrollToOffset}"></a>
                                                </div>
                                            </v-form>
                                        </template>
                                    </v-card>
                                </v-card-text>
                                <SearchTable id="citySearchTable" type="city" :permissionName="permissionName" :trucks="trucks.cityTrucks" :getTrucks="getTrucksForCitySearch" :selectedTab="selectedTab"></SearchTable>
                            </v-card>
                        </v-tab-item>
                        <!-- City Search Tab Item End -->
                        <!-- Map Search Tab Item Start -->
                        <v-tab-item>
                            <v-card flat>
                                <v-card-text class="customPanel">
                                    <v-card>
                                        <template>
                                            <v-form @submit.prevent="submitMapSearchForm('mapSearchForm')" data-vv-scope="mapSearchForm">
                                                <v-container grid-list-xl fluid>
                                                    <v-layout row wrap>
                                                        <v-flex md8 xs12>
                                                            <div class="d-flex">
                                                                <v-text-field required placeholder="Anywhere" autocomplete="off" v-validate="{map_origin_address: [hidden_map_origin_address]}" :error-messages="errors.collect('mapSearchForm.map_origin_address')" label="Origin" v-model="form.mapSearch.origin_address" id="map_origin_address" data-vv-name="map_origin_address" @input="getAddressData('map_origin_address')" data-vv-as="Origin Address">
                                                                </v-text-field>
                                                                <input :type="'hidden'" v-model="hidden_map_origin_address" ref="hidden_map_origin_address" data-vv-name="hidden_map_origin_address" />
                                                                    </div>
                                                        </v-flex>
                                                        <v-flex lg4 md4 xs12>
                                                            <div class="d-flex">
                                                                <v-combobox data-vv-name="origin_radius" :return-object="false" :items="utils.radiuslist" item-text="name" item-value="id" v-validate="{numeric_radius: 'form.mapSearchForm.origin_radius'}" :error-messages="errors.collect('mapSearchForm.origin_radius')" data-vv-as="radius" label="Radius in miles" v-model="form.mapSearch.origin_radius" @keyup="onMapRadiusChange"></v-combobox>
                                                            </div>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex lg8 md8 xs12>
                                                            <div v-bind:class="showSugg">
                                                                <v-autocomplete :menu-props="{'maxHeight':150}" label="Destinations" placeholder="Anywhere" v-model="bothStatesObj" :items="bothStates" item-value="id" id="map_dest_address" item-text="statename" multiple clearable required v-validate="{dest_address_count: []}" :error-messages="errors.collect('mapSearchForm.map_dest_address')" data-vv-name="map_dest_address" data-vv-as="Destination Address">
                                                                    <template slot="selection" slot-scope="data">
                                                                        <v-chip data-vv-scope="mapSearchForm" :selected="data.selected" close class="chip--select-multi" @input="removeAutoDestChips(data.item.id)">
                                                                            {{ data.item.statename }}
                                                                        </v-chip>
                                                                    </template>
                                                                    <template slot="item" slot-scope="data" class="custom-dropdown">
                                                                        <template v-if="typeof data.item !== 'object'">
                                                                            <v-list-tile-content v-text="data.item.statename"></v-list-tile-content>
                                                                        </template>
                                                                        <template v-else>
                                                                            <v-list-tile-content>
                                                                                <v-list-tile-title v-html="data.item.statename"></v-list-tile-title>
                                                                            </v-list-tile-content>
                                                                        </template>
                                                                    </template>
                                                                </v-autocomplete>
                                                            </div>
                                                        </v-flex>
                                                        <v-flex lg4 md4 xs12>
                                                            <div class="d-flex">
                                                                <v-autocomplete class="auotchoice" :items="mapSearch_equipment_types" v-validate="{required:'mapSearchForm.equipment_types'}" :error-messages="errors.collect('mapSearchForm.equipment_types')" data-vv-name="equipment_types" data-vv-rules="equipment_types" v-model="mapSearch_equipment_type_id_list" required data-vv-as="Equipment Types" item-text="name" item-value="code" label="Equipment Types *" multiple v-on:change="onEquipmentChange('mapSearch',$event)"></v-autocomplete>
                                                            </div>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-layout row wrap>
                                                        <v-flex lg4 md4 xs12>
                                                            <v-menu ref="map_picker_available_date" lazy :close-on-content-click="false" v-model="form.mapSearch.picker_available_date" transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px" :return-value.sync="form.mapSearch.available_date">
                                                                <v-text-field class="custom-picker-text" id="available_date" v-validate="'required'" data-vv-name="available_date" data-vv-as="Available Date" :error-messages="errors.collect('mapSearchForm.available_date')" slot="activator" label="Available Date *" :value="displayDate(form.mapSearch.available_date)" prepend-icon="event" readonly></v-text-field>
                                                                <v-date-picker :min="minDate" v-model="form.mapSearch.available_date" no-title scrollable @input="changePickerDate('available'); $refs.map_picker_available_date.save(form.mapSearch.available_date)">
                                                                </v-date-picker>
                                                            </v-menu>
                                                        </v-flex>
                                                        <v-flex lg4 md4 xs12>
                                                            <div class="d-flex">
                                                                <v-select class="custom_dropdown" :items="truck_size_arr" :error-messages="errors.collect('load_size')" data-vv-name="load_size" v-model="form.mapSearch.load_size" required data-vv-as="Load Size" item-text="name" item-value="id" label="Load Size">
                                                                </v-select>
                                                            </div>
                                                        </v-flex>
                                                    </v-layout>

                                                    </v-container>
                                                    <div class="form-btn text-xs-right">
                                                        <v-btn type="submit" color="green darken- white--text"><v-icon>search</v-icon> Find Trucks</v-btn>
                                                        <a href="#" id="scrollTopMapSearchTable" v-scroll-to="{'el':'#mapSearchTable','offset':-mapSearchScrollToOffset}"></a>
                                                    </div>

                                                <v-tabs slider-color="orange">
                                                    <v-tab ripple> UNITED STATES </v-tab>
                                                    <v-tab ripple> CANADA </v-tab>
                                                    <v-tab ripple> BOTH </v-tab>
                                                    <v-tab-item>
                                                        <v-container grid-list-xl fluid class="text-xs-center">
                                                            <div id="us-info-box"></div>
                                                            <svg  version="1.1" id="us-map" preserveAspectRatio="xMinYMin meet" sodipodi:docname="" inkscape:version="0.91 r13725" x="0px" y="0px"width="959px" height="593px" viewBox="174 100 959 593" enable-background="new 174 100 959 593" xml:space="preserve">
                                                                            <g id="usSvg">
                                                                                <template v-for="value in usSvgObj">
                                                                                    <path :id="value.id" :class="value.class" :datainfo="value.datainfo" :fill="value.fill" :d="value.d" :statename="value.statename" />
                                                                                </template>
                                                                            </g>
                                                                        </svg>
                                                        </v-container>
                                                    </v-tab-item>
                                                    <v-tab-item>
                                                        <v-container grid-list-xl fluid class="text-xs-center">
                                                            <div id="canada-info-box"></div>
                                                            <svg version="1.1"  height="800px"  width="700"
                                                                    xmlns="" viewBox="0 0 1300 200" preserveAspectRatio="xMinYMin">
                                                                            <g id="canadaSvg">
                                                                                <template v-for="value in canadaSvgObj">
                                                                                    <path  :id="value.id" :class="value.class" :datainfo="value.datainfo" :fill="value.fill" :d="value.d" :statename="value.statename" />
                                                                                </template>
                                                                            </g>
                                                                        </svg>
                                                        </v-container>
                                                    </v-tab-item>
                                                    <v-tab-item>
                                                        <v-container grid-list-xl fluid class="text-xs-center">
                                                            <v-layout row wrap>
                                                                <v-flex lg6 md6 xs12>
                                                                    <div id="both-us-info-box"></div>
                                                                    <svg  version="1.1" id="both-us-map"
                                                                        preserveAspectRatio="xMinYMin meet"
                                                                         width="500px" height="593px"
                                                                        sodipodi:docname=""
                                                                        inkscape:version="0.91 r13725" x="0px" y="0px"

                                                                        viewBox="174 100 959 593" enable-background="new 174 100 959 593" xml:space="preserve">
                                                                                <g id="both-usSvg">
                                                                                    <template v-for="value in usSvgObj">
                                                                                        <path :id="value.id" :class="value.class" :datainfo="value.datainfo" :fill="value.fill" :d="value.d" :statename="value.statename" />
                                                                                    </template>
                                                                                </g>
                                                                            </svg>
                                                                </v-flex>
                                                                <v-flex lg6 md6 xs12>
                                                                    <div id="both-canada-info-box"></div>
                                                                    <svg height="600" version="1.1" width="600"
                                                                        xmlns="" viewBox="0 0 1100 200" preserveAspectRatio="xMinYMin">
                                                                                <g id="both-canadaSvg">
                                                                                    <template v-for="value in canadaSvgObj">
                                                                                        <path  :id="value.id" :class="value.class" :datainfo="value.datainfo" :fill="value.fill" :d="value.d" :statename="value.statename" />
                                                                                    </template>
                                                                                </g>
                                                                            </svg>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-tab-item>
                                                </v-tabs>
                                            </v-form>
                                        </template>
                                    </v-card>

                                </v-card-text>
                                <SearchTable id="mapSearchTable" type="map" :permissionName="permissionName" :trucks="trucks.mapTrucks" :getTrucks="getTrucksForMapSearch" :selectedTab="selectedTab"></SearchTable>
                            </v-card>
                        </v-tab-item>
                        <!-- Map Search Tab Item End -->
                    </v-tabs>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
<div v-else id="pageTable" class="my-trucks">
    <v-container grid-list-xl fluid paddingZero>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <v-card-text v-if="showSearchFormMob" class="customPanel">
                        <template>
                            <v-form @submit.prevent="submitCitySearchForm('citySearchForm')" data-vv-scope="citySearchForm">
                                <v-container grid-list-xl fluid>
                                    <v-layout row wrap>
                                        <v-flex md8 xs12>
                                            <div class="d-flex">
                                                <v-text-field label="Origin" placeholder="Anywhere" autocomplete="off" v-validate="{origin_address: [hidden_city_origin_address]}" v-model="form.citySearch.origin_address" :error-messages="errors.collect('citySearchForm.city_origin_address')" id="city_origin_address" data-vv-name="city_origin_address" v-on:keyup="clearCitySearchAddressBar" data-vv-as="Origin Address">
                                                </v-text-field>
                                                <input :type="'hidden'" v-model="hidden_city_origin_address" ref="hidden_city_origin_address" data-vv-name="hidden_city_origin_address" />
                                                                    </div>
                                        </v-flex>
                                        <v-flex md4 xs12>
                                            <div class="d-flex">
                                                <v-combobox v-model="form.citySearch.origin_radius" :return-object="false" :items="utils.radiuslist" item-text="name" item-value="id" label="Radius in miles" v-validate="{numeric_radius: 'form.citySearchForm.origin_radius'}" :error-messages="errors.collect('citySearchForm.city_origin_radius')" id="city_origin_radius" data-vv-name="city_origin_radius" data-vv-as="Radius" placeholder="Radius" @keyup="onOriginRadiusChange"></v-combobox>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex md8 xs12>
                                            <div class="d-flex">
                                                <v-text-field :class="form.citySearch.destination_cities.length ? 'white-placeholder': ''" label="Destination" autocomplete="off" placeholder="Anywhere" v-model="form.citySearch.dest_address" :error-messages="errors.collect('citySearchForm.city_dest_address')" v-validate="{city_dest_address:true}" id="city_dest_address" data-vv-name="city_dest_address" data-vv-as="Destination Address">
                                                </v-text-field>
                                                <input :type="'hidden'" v-model="hidden_city_dest_address" ref="hidden_city_dest_address" data-vv-name="hidden_city_dest_address" />
                                                                    </div>
                                                <div v-if="form.citySearch.destination_cities.length" :class="!errors.collect('citySearchForm.city_dest_address').length ? 'customChip' : ''">
                                                    <v-chip @input="cityDestChipChange(index)" close v-for="(item, index) in form.citySearch.destination_cities" v-bind:key="index">
                                                        {{item.dest_city}},&nbsp;{{item.state_code}}
                                                    </v-chip>
                                                </div>
                                        </v-flex>
                                        <v-flex md4 xs12>
                                            <div class="d-flex">
                                                <v-combobox v-model="form.citySearch.dest_radius" :return-object="false" :items="utils.radiuslist" item-text="name" item-value="id" label="Radius in miles" v-validate="{numeric_radius: 'form.citySearchForm.city_dest_radius'}" :error-messages="errors.collect('citySearchForm.city_dest_radius')" id="city_dest_radius" data-vv-name="city_dest_radius" data-vv-as="Radius" placeholder="Radius" @keyup="onDestRadiusChange"></v-combobox>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex lg4 md4 xs12>
                                            <v-menu ref="city_picker_available_date" lazy :close-on-content-click="false" v-model="form.citySearch.picker_available_date" transition="scale-transition" offset-y full-width :nudge-right="40" min-width="290px" :return-value.sync="form.citySearch.available_date">
                                                <v-text-field class="custom-picker-text" id="available_date" v-validate="'required'" data-vv-name="available_date" data-vv-as="Available Date" :error-messages="errors.collect('citySearchForm.available_date')" slot="activator" label="Available Date *" :value="displayDate(form.citySearch.available_date)" prepend-icon="event" readonly></v-text-field>
                                                <v-date-picker :min="minDate" v-model="form.citySearch.available_date" no-title scrollable @input="changePickerDate('available'); $refs.city_picker_available_date.save(form.citySearch.available_date)">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-flex lg4 md4 xs12>
                                            <div class="d-flex">
                                                <v-autocomplete class="auotchoice" v-validate="{required:'citySearchForm.equipment_types'}" :items="citySearch_equipment_types" :error-messages="errors.collect('citySearchForm.equipment_types')" data-vv-name="equipment_types" data-vv-rules="equipment_types" v-model="citySearch_equipment_type_id_list" required data-vv-as="Equipment Types" item-text="name" item-value="code" label="Equipment Types *" multiple v-on:change="onEquipmentChange('citySearch',$event)"></v-autocomplete>
                                            </div>
                                        </v-flex>
                                        <v-flex lg4 md4 xs12>
                                            <div class="d-flex">
                                                <v-select class="custom_dropdown" :items="truck_size_arr" :error-messages="errors.collect('load_size')" data-vv-name="load_size" v-model="form.citySearch.load_size" required data-vv-as="Load Size" item-text="name" item-value="id" label="Load Size">
                                                </v-select>
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                                <div class="form-btn text-xs-right">
                                    <v-btn type="submit" color="green darken- white--text">
                                        <v-icon>search</v-icon> Find Trucks
                                    </v-btn>
                                </div>
                            </v-form>
                        </template>
                    </v-card-text>
                    <v-toolbar color="grey darken-1 minheight" dark @click="showSearchFormMob=true">
                        <v-flex xs12 md3 text-xs-center pa-0>
                            <strong>{{this.totalRecords }}</strong> Trucks found from
                            {{this.form.citySearch.origin_address != '' ? this.form.citySearch.origin_address : anywhereStr }}
                            to
                            {{this.form.citySearch.dest_address != '' ? this.form.citySearch.dest_address : anywhereStr }} <br/>
                            Equipment <strong>{{citySearch_equipment_name}}</strong></span> | 
                            Load Size <strong>{{newLoadSizeForMobile != '' ? newLoadSizeForMobile : ANYStr}}</strong></span>
                        </v-flex>
                    </v-toolbar>
                    <SearchTable type="city" :clientUserAgent="clientUserAgent" :permissionName="permissionName" :trucks="trucks.cityTrucks" :getTrucks="getTrucksForCitySearch" :selectedTab="selectedTab"></SearchTable>
                </v-card>
                <v-card>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>
<script>
const ADDRESS_COMPONENTS = {
    subpremise: 'short_name',
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'long_name',
    administrative_area_level_2: 'long_name',
    country: 'long_name',
    postal_code: 'short_name'
};
import GoogleAds from "@/pages/widgets/GoogleAds";
import API from "@/api";
import services from "../../services/HttpService";
import breadcrumbs from "../widgets/Breadcrumb";
import Material from "vuetify/es5/util/colors";
import SearchTable from "./SearchTable";
import moment from 'moment';
import utils from '../../util/';
import config from "../../config";
import {
    Validator
} from 'vee-validate';
import { setTimeout } from 'timers';
Validator.extend('map_origin_address', {
    getMessage: field => 'The ' + field + ' field is Invalid.',
    validate: function (value, [oth]) {
        if (oth == '') {
            return false;
        }
        return true;
    }
});

Validator.extend('dest_address_count', {
    getMessage: field => 'The ' + field + ' not allowed more than 5.',
    validate: function (value, [hidden_map_dest_city_count]) {
        if (value.length > 5) {
            return false;
        }
        return true;
    }
});

Validator.extend('origin_address', {
    getMessage: field => 'The ' + field + ' field is Invalid.',
    validate: function (value, [oth]) {
        if (oth == '') {
            return false;
        }
        return true;
    }
});

export default {
    $_veeValidate: {
        validator: 'new'
    },
    components: {
        breadcrumbs,
        SearchTable,
        GoogleAds
    },
    async created() {
        this.utils = utils;
        window.intervals = {
            'city': 0,
            'map': 0
        };
        const self = this;
        self.clientUserAgent = utils.getUserAgent();
        await self.getEquipmentTypes();
    },
    computed: {
        minDate() {
            const today = new Date();
            return this.formatDate(today);
        },
        scrollingOptions () {
            return {
                duration: config.scrollingOptionDuration,
                offset: config.scrollingOptionOffset,
                easing: config.scrollingOptionEasing
            }
        }
    },
    watch: {
        bothStatesObj(val) {
            const self = this;
            let newDataObj = [];
            self.$data.bothStates.map(function (data) {
                if (val.includes(data.id)) {
                    newDataObj.push(data.statename);
                }
            });
            self.$data.form.mapSearch.destination_cities = newDataObj;
            self.$data.hidden_map_dest_city_count = newDataObj.length;
            if (!self.clientUserAgent) {
                self.mapChanges();
                self.mapChangesBoth();
            }
        },
        'form.mapSearch.origin_address': function (val, oldVal) {
            const self = this;
            if (val === '') {
                self.form.mapSearch.origin_city = '';
                self.form.mapSearch.lat = '';
                self.form.mapSearch.lng = '';
                self.form.mapSearch.origin_state = '';
                self.mapChangesOrigin();
                self.mapChangesOriginBoth();
            }
        }
    },
    beforeRouteLeave(to, from, next) {
        clearInterval(window.intervals.city);
        clearInterval(window.intervals.map);
        next();
    },
    mounted() {
        const self = this;
        setTimeout(function () {
            if(document.getElementById('city_origin_address') && document.getElementById('city_dest_address')){
                document.getElementById('city_origin_address').setAttribute('autocomplete', 'disabled');
                document.getElementById('city_dest_address').setAttribute('autocomplete', 'disabled');
            }
        }, 1000);
        self.$validator.localize('en', self.dictionary);
        self.permissionName = this.$store.state.user ? self.$store.state.user.permissions.trucks : null;
        let params = '';
        if (typeof self.$route.params.queryString != 'undefined') {
            params = self.$route.params.queryString;
            self.form.citySearch = self.$route.params.originalData;
            self.showSearchFormMob = false;
            if (self.form.citySearch.equipment_type_id != config.ANYStr) {
                let selectedEquipmentList = self.form.citySearch.equipment_type_id.split(',');
                self.citySearch_equipment_type_id_list = [];
                selectedEquipmentList.map(function (data) {
                    self.citySearch_equipment_type_id_list.push(data);
                });
            } else {
                self.citySearch_equipment_type_id_list = [];
                self.citySearch_equipment_type_id_list.push(config.ANYStr);
            }
            self.hidden_city_origin_address = self.$route.params.originalData.origin_address;
        }
        self.getTrucks(true, trucks => {
            self.trucks.savedSearchTrucks = trucks.slice(0);
            self.trucks.cityTrucks = trucks.slice(0);
            self.trucks.mapTrucks = trucks.slice(0);
            if(document.getElementById("scrollTopCitySearchTable")){
                document.getElementById("scrollTopCitySearchTable").click();
            }
        }, params);
        self.initGoogleAutocomplete();
        if (!self.clientUserAgent) {
            self.initUsSvgMap();
            self.initCanadaSvgMap();
        }
    },
    methods: {
        onTabChange(tab) {
            this.selectedTab = tab;
        },
        displayDate(selectedDate, type) {
            if (this.form.citySearch.available_date && this.form.citySearch.available_date.length > 0) {
                return moment(selectedDate).format(config.displayDateFormat);
            }
            return '';
        },
        initUsSvgMap() {
            const self = this;
            let usSvgObjId = document.getElementById("usSvg");
            var svgDoc = usSvgObjId.getElementsByTagName("path");
            for (var i = 0; i < svgDoc.length; i++) {
                svgDoc[i].addEventListener("click", function (data) {
                    var stateId = data.currentTarget.getAttribute("id");
                    if (!self.bothStatesObj.includes(stateId)) {
                        self.bothStatesObj.push(stateId);
                    } else {
                        self.bothStatesObj.splice(self.bothStatesObj.indexOf(stateId), 1);
                    }

                });
                svgDoc[i].addEventListener("mouseover", function (data) {
                    var dataInfo = data.currentTarget.getAttribute("datainfo");
                    document.getElementById('us-info-box').innerHTML = dataInfo;
                    document.getElementById('us-info-box').style.display = 'block';

                });
                svgDoc[i].addEventListener("mousemove", function (event) {
                    document.getElementById('us-info-box').style.top = (event.pageY - (document.getElementById('us-info-box').offsetHeight) - 30 - 500).toString() + "px";
                    document.getElementById('us-info-box').style.left = ((event.pageX - (document.getElementById('us-info-box').offsetWidth) / 2) - 200).toString() + "px";
                });
            }
            usSvgObjId.addEventListener("mouseleave", function (event) {
                document.getElementById('us-info-box').style.display = 'none';
            })
            //functionality for both map for US
            this.initUsSvgMapBoth();
        },
        initUsSvgMapBoth() {
            const self = this;
            let usSvgObjId = document.getElementById("both-usSvg");
            var svgDoc = usSvgObjId.getElementsByTagName("path");
            for (var i = 0; i < svgDoc.length; i++) {
                svgDoc[i].addEventListener("click", function (data) {
                    var stateId = data.currentTarget.getAttribute("id");
                    if (!self.bothStatesObj.includes(stateId)) {
                        self.bothStatesObj.push(stateId);
                    } else {
                        self.bothStatesObj.splice(self.bothStatesObj.indexOf(stateId), 1);
                    }
                });
                svgDoc[i].addEventListener("mouseover", function (data) {
                    var dataInfo = data.currentTarget.getAttribute("datainfo");
                    document.getElementById('both-us-info-box').innerHTML = dataInfo;
                    document.getElementById('both-us-info-box').style.display = 'block';

                })
                svgDoc[i].addEventListener("mousemove", function (event) {
                    document.getElementById('both-us-info-box').style.top = (event.pageY - (document.getElementById('both-us-info-box').offsetHeight) - 30 - 500).toString() + "px";
                    document.getElementById('both-us-info-box').style.left = ((event.pageX - (document.getElementById('both-us-info-box').offsetWidth) / 2) - 200).toString() + "px";
                })
            }
            usSvgObjId.addEventListener("mouseleave", function (event) {
                document.getElementById('both-us-info-box').style.display = 'none';
            })
        },
        initCanadaSvgMap() {
            const self = this;
            let canadaSvgObjId = document.getElementById("canadaSvg");
            var svgDoc = canadaSvgObjId.getElementsByTagName("path");
            for (var i = 0; i < svgDoc.length; i++) {
                svgDoc[i].addEventListener("click", function (data) {
                    var stateId = data.currentTarget.getAttribute("id");
                    if (!self.bothStatesObj.includes(stateId)) {
                        self.bothStatesObj.push(stateId);
                    } else {
                        self.bothStatesObj.splice(self.bothStatesObj.indexOf(stateId), 1);
                    }
                });
                svgDoc[i].addEventListener("mouseover", function (data) {
                    var dataInfo = data.currentTarget.getAttribute("datainfo");
                    document.getElementById('canada-info-box').innerHTML = dataInfo;
                    document.getElementById('canada-info-box').style.display = 'block';
                });
                svgDoc[i].addEventListener("mousemove", function (event) {
                    document.getElementById('canada-info-box').style.top = (event.pageY - (document.getElementById('canada-info-box').offsetHeight) - 30 - 500).toString() + "px";
                    document.getElementById('canada-info-box').style.left = ((event.pageX - (document.getElementById('canada-info-box').offsetWidth) / 2) - 200).toString() + "px";
                });
            }
            canadaSvgObjId.addEventListener("mouseleave", function (event) {
                document.getElementById('canada-info-box').style.display = 'none';
            })
            //functionality for both map for CANADA
            this.initCanadaSvgMapBoth();
        },
        initCanadaSvgMapBoth() {
            const self = this;
            let canadaSvgObjId = document.getElementById("both-canadaSvg");
            var svgDoc = canadaSvgObjId.getElementsByTagName("path");
            for (var i = 0; i < svgDoc.length; i++) {
                svgDoc[i].addEventListener("click", function (data) {
                    var stateId = data.currentTarget.getAttribute("id");
                    if (!self.bothStatesObj.includes(stateId)) {
                        self.bothStatesObj.push(stateId);
                    } else {
                        self.bothStatesObj.splice(self.bothStatesObj.indexOf(stateId), 1);
                    }
                });
                svgDoc[i].addEventListener("mouseover", function (data) {
                    var dataInfo = data.currentTarget.getAttribute("datainfo");
                    document.getElementById('both-canada-info-box').innerHTML = dataInfo;
                    document.getElementById('both-canada-info-box').style.display = 'block';
                });
                svgDoc[i].addEventListener("mousemove", function (event) {
                    document.getElementById('both-canada-info-box').style.top = (event.pageY - (document.getElementById('both-canada-info-box').offsetHeight) - 30 - 500).toString() + "px";
                    document.getElementById('both-canada-info-box').style.left = ((event.pageX - (document.getElementById('both-canada-info-box').offsetWidth) / 2) - 200).toString() + "px";
                });
            }
            canadaSvgObjId.addEventListener("mouseleave", function (event) {
                document.getElementById('both-canada-info-box').style.display = 'none';
            });
        },
        mapChanges() {
            const self = this;
            let val = self.bothStatesObj;
            let usSvgObjId = document.getElementById("usSvg");
            var usSvgDoc = usSvgObjId.getElementsByTagName("path");
            for (var i = 0; i < usSvgDoc.length; i++) {
                if (usSvgDoc[i].getAttribute("id") != self.origin_map_state_code) {
                    if (val.includes(usSvgDoc[i].getAttribute("id"))) {
                        usSvgDoc[i].setAttribute("fill", '#ff812b');
                    } else {
                        usSvgDoc[i].setAttribute("fill", '#D3D3D3');
                    }
                }
            }
            let canadaSvgObjId = document.getElementById("canadaSvg");
            var canadaSvgDoc = canadaSvgObjId.getElementsByTagName("path");
            for (var i = 0; i < canadaSvgDoc.length; i++) {
                if (canadaSvgDoc[i].getAttribute("id") != self.origin_map_state_code) {
                    if (val.includes(canadaSvgDoc[i].getAttribute("id"))) {
                        canadaSvgDoc[i].setAttribute("fill", '#ff812b');
                    } else {
                        canadaSvgDoc[i].setAttribute("fill", '#D3D3D3');
                    }
                }
            }
        },
        mapChangesBoth() {
            const self = this;
            let val = self.bothStatesObj;
            let usSvgObjId = document.getElementById("both-usSvg");
            var usSvgDoc = usSvgObjId.getElementsByTagName("path");
            for (var i = 0; i < usSvgDoc.length; i++) {
                if (usSvgDoc[i].getAttribute("id") != self.origin_map_state_code) {
                    if (val.includes(usSvgDoc[i].getAttribute("id"))) {
                        usSvgDoc[i].setAttribute("fill", '#ff812b');
                    } else {
                        usSvgDoc[i].setAttribute("fill", '#D3D3D3');
                    }
                }
            }
            let canadaSvgObjId = document.getElementById("both-canadaSvg");
            var canadaSvgDoc = canadaSvgObjId.getElementsByTagName("path");
            for (var i = 0; i < canadaSvgDoc.length; i++) {
                if (canadaSvgDoc[i].getAttribute("id") != self.origin_map_state_code) {
                    if (val.includes(canadaSvgDoc[i].getAttribute("id"))) {
                        canadaSvgDoc[i].setAttribute("fill", '#ff812b');
                    } else {
                        canadaSvgDoc[i].setAttribute("fill", '#D3D3D3');
                    }
                }
            }
        },
        mapChangesOrigin() {
            const self = this;
            let val = self.form.mapSearch.origin_state;

            let canadaSvgObjId = document.getElementById("canadaSvg");
            var canadaSvgDoc = canadaSvgObjId.getElementsByTagName("path");
            for (var i = 0; i < canadaSvgDoc.length; i++) {
                if (val == canadaSvgDoc[i].getAttribute("statename")) {
                    canadaSvgDoc[i].setAttribute("fill", '#4caf50');
                } else {
                    if (self.bothStatesObj.includes(canadaSvgDoc[i].getAttribute("id"))) {
                        canadaSvgDoc[i].setAttribute("fill", '#ff812b');
                    } else {
                        canadaSvgDoc[i].setAttribute("fill", '#D3D3D3');
                    }
                }
            }
            let usSvgObjId = document.getElementById("usSvg");
            var usSvgDoc = usSvgObjId.getElementsByTagName("path");
            for (var i = 0; i < usSvgDoc.length; i++) {
                if (val == usSvgDoc[i].getAttribute("statename")) {
                    usSvgDoc[i].setAttribute("fill", '#4caf50');
                } else {
                    if (self.bothStatesObj.includes(usSvgDoc[i].getAttribute("id"))) {
                        usSvgDoc[i].setAttribute("fill", '#ff812b');
                    } else {
                        usSvgDoc[i].setAttribute("fill", '#D3D3D3');
                    }
                }
            }
        },
        mapChangesOriginBoth() {
            const self = this;
            let val = self.form.mapSearch.origin_state;

            let canadaSvgObjId = document.getElementById("both-canadaSvg");
            var canadaSvgDoc = canadaSvgObjId.getElementsByTagName("path");
            for (var i = 0; i < canadaSvgDoc.length; i++) {
                if (val == canadaSvgDoc[i].getAttribute("statename")) {
                    canadaSvgDoc[i].setAttribute("fill", '#4caf50');
                } else {
                    if (self.bothStatesObj.includes(canadaSvgDoc[i].getAttribute("id"))) {
                        canadaSvgDoc[i].setAttribute("fill", '#ff812b');
                    } else {
                        canadaSvgDoc[i].setAttribute("fill", '#D3D3D3');
                    }
                }
            }
            let usSvgObjId = document.getElementById("both-usSvg");
            var usSvgDoc = usSvgObjId.getElementsByTagName("path");
            for (var i = 0; i < usSvgDoc.length; i++) {
                if (val == usSvgDoc[i].getAttribute("statename")) {
                    usSvgDoc[i].setAttribute("fill", '#4caf50');
                } else {
                    if (self.bothStatesObj.includes(usSvgDoc[i].getAttribute("id"))) {
                        usSvgDoc[i].setAttribute("fill", '#ff812b');
                    } else {
                        usSvgDoc[i].setAttribute("fill", '#D3D3D3');
                    }
                }
            }
        },
        initGoogleAutocomplete() {
            if (!this.clientUserAgent) {
                this.bindAutocompleteEv('origin', 'map');
            }
            this.bindAutocompleteEv('origin', 'city');
            this.bindAutocompleteEv('dest', 'city');
        },
        addPlaceToDestinations(tabType, location) {
            const citySearch = this.form.citySearch;
            if (this._checkIfDestExists(location)) {
                if(location.dest_city != '' || location.state_code != '' || location.state_name != ''){
                    location.lat = location.lat.toString();
                    location.lng = location.lng.toString();
                    citySearch.destination_cities.push(location);
                }
            }
            citySearch.dest_address = '';
            citySearch.dest_city = '';
            citySearch.dest_lat = '';
            citySearch.dest_lng = '';
        },
        _checkIfDestExists(location) {
            const destinations = this.form.citySearch.destination_cities;
            let isValid = true;
            for (var i = 0; i < destinations.length; i++) {
                if (destinations[i].lat == location.lat && destinations[i].lng == location.lng) {
                    isValid = false;
                    break;
                }
            }
            return isValid;
        },
        cityDestChipChange(i) {
            this.form.citySearch.destination_cities.splice(i, 1);
        },
        bindAutocompleteEv(placeType, tabType) {
            const self = this,
                options = {};
            let acInstance = self[placeType + '_autocomplete'];
            acInstance = new google.maps.places.Autocomplete(
                document.getElementById(tabType + '_' + placeType + '_address'),
                options
            );
            acInstance.setComponentRestrictions({
                'country': ['CAN', 'US']
            });
            acInstance.addListener('place_changed', function () {
                let place = acInstance.getPlace();
                if (place.address_components !== undefined) {
                    let returnData = {};

                    for (let i = 0; i < place.address_components.length; i++) {
                        let addressType = place.address_components[i].types[0];

                        if (addressType == 'administrative_area_level_1') {
                            let val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
                            returnData[addressType] = val;
                            returnData['origin_map_state_code'] = place.address_components[i]['short_name'];
                            returnData['state_name'] = place.address_components[i]['long_name'];
                        } else if (ADDRESS_COMPONENTS[addressType]) {
                            let val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
                            returnData[addressType] = val;
                        }
                    }
                    const searchField = self.form[tabType + 'Search'],
                        lat = place.geometry.location.lat(),
                        lng = place.geometry.location.lng(),
                        city = returnData.locality;
                    if (tabType === 'city' && placeType === 'dest') {
                        self.form.citySearch.selected_dest = {
                            lat,
                            lng
                        };
                        self.$validator.validateAll('city_dest_address');
                        self.addPlaceToDestinations(tabType, {
                            lat,
                            lng,
                            'dest_city': city ? city : '',
                            'state_code':returnData.origin_map_state_code ? returnData.origin_map_state_code : '',
                            'state_name': returnData.state_name ? returnData.state_name : ''
                        });
                    } else {
                        searchField[placeType + '_address'] = place.formatted_address;
                        searchField[placeType + '_city'] = city;
                        searchField[placeType + '_state'] = returnData.administrative_area_level_1;
                        self['hidden_' + tabType + '_' + placeType + '_address'] = place.formatted_address;
                        searchField[placeType + '_lat'] = lat;
                        searchField[placeType + '_lng'] = lng;
                        if (tabType == 'map') {
                            searchField[placeType + '_city'] = returnData.administrative_area_level_1;
                            self.origin_map_state_code = returnData.origin_map_state_code;
                            self.mapChangesOrigin();
                            self.mapChangesOriginBoth();
                        }
                    }
                } else {
                    self['hidden_' + tabType + '_' + placeType + '_address'] = '';
                }
            });
        },
        submitCitySearchForm(scope) {
            const self = this;
            self.$validator.validateAll(scope)
                .then(isValid => {
                    if (isValid) {
                        self.showSearchFormMob = false;
                        self.getTrucksForCitySearch(true);
                        if(document.getElementById("scrollTopCitySearchTable")){
                            document.getElementById("scrollTopCitySearchTable").click();
                        }
                    }
                });
        },
        getTrucksForCitySearch(showLoader = false) {
            const self = this,
                params = this._formatCitySearchForm();
            self.searchType = config.cityStr;
            self.getTrucks(showLoader, trucks => {
                self.trucks.cityTrucks = trucks.slice(0);
            }, params);
        },
        getTrucksForMapSearch(showLoader = false) {
            const self = this,
                params = this._formatMapSearchForm();
            self.searchType = config.mapStr;
            this.getTrucks(showLoader, trucks => {
                self.trucks.mapTrucks = trucks.slice(0);
            }, params);
        },
        submitMapSearchForm(scope) {
            const self = this;
            self.$validator.validateAll(scope)
                .then(isValid => {
                    if (isValid) {
                        self.getTrucksForMapSearch(true);
                        if(document.getElementById("scrollTopMapSearchTable")){
                            document.getElementById("scrollTopMapSearchTable").click();
                        }
                    }
                });
        },
        removeDestChips(item) {
        },
        removeAutoDestChips(item) {
            this.bothStatesObj.splice(this.bothStatesObj.indexOf(item), 1);
            this.mapChanges();
            this.mapChangesBoth();
        },
        clearDestChips(item) {
        },
        getAddressData(data) {
            const self = this;

            if (self.bothStatesObj.indexOf(self.origin_map_state_code) >= 0) {
                self.bothStatesObj.splice(self.bothStatesObj.indexOf(self.origin_map_state_code), 1);
                self.bothStatesObj.push(self.origin_map_state_code);
            }
            self.origin_map_state_code = '';
            self['hidden_' + data] = '';
            if (!self.clientUserAgent) {
                self.mapChanges();
                self.mapChangesBoth();
                self.mapChangesOrigin();
                self.mapChangesOriginBoth();
            }

        },
        async getTrucks(showLoader = true, cb, params) {
            const self = this,
                wApp = window.getApp;
            if (showLoader) {
                wApp.$emit("showLoader", {
                    show: true
                });
            }
            let url = "trucks/list?show_all=true";
            if (params) {
                url += "&" + params;
            }
            await services.get(url, {Authorization: "Bearer " + this.$store.state.user.token}).then(res => {
                setTimeout(function(){
                    utils.getEquipmentListDisplay(self.citySearch_equipment_type_id_list.join(','),self.equipment_type_codes,self.citySearch_equipment_types,config.longFormStr,function(result){
                        self.citySearch_equipment_name = result;
                    });
                    self.totalRecords = res.data.data.length
                    self.newLoadSizeForMobile = self.form.citySearch.load_size;
                    const filteredLoads = res.data.data.map((dt, i) => {
                        dt.origin = dt.origin_city + ', ' + dt.origin_state;
                        dt.dest = dt.dest_city + ', ' + dt.dest_state;
                        dt.age = utils.dateDiff(self.currDate, dt.created_date, 's');
                        dt.ind = i;
                        dt.age_display = utils.getDateDiffDisplay(dt.created_date);
                        if(self.searchType == config.cityStr){
                            utils.getEquipmentListDisplay(dt.equipment_type_ids,self.equipment_type_codes,self.citySearch_equipment_types,config.shortFormStr,function(result){
                                dt.equipment_name = result;
                            });
                        }else if(self.searchType == config.mapStr){
                            utils.getEquipmentListDisplay(dt.equipment_type_ids,self.equipment_type_codes,self.mapSearch_equipment_types,config.shortFormStr,function(result){
                                dt.equipment_name = result;
                            });
                        }
                        return dt;
                    });
                    if (showLoader) {
                        wApp.$emit("showLoader", {
                            show: false
                        });
                    }
                    if (typeof cb === 'function') {
                        cb(filteredLoads);
                    }
                },config.setTimeOutForLoadAndTruckEquipmentType);
            }).catch(err => {
                if (showLoader) {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                }
                self._showToast(err.message, config.errMsgColorStr);
            });
        },
        async getEquipmentTypes() {
            const self = this;
            await services.get("equipments/list", {'Authorization': 'Bearer ' + this.$store.state.user.token}).then(res => {
                let anyObject = {
                    'name': config.ANYStr,
                    'code': config.ANYStr
                };
                self.citySearch_equipment_types.push(anyObject);
                self.mapSearch_equipment_types.push(anyObject);
                self.equipment_type_codes.push(anyObject.code);
                res.data.data.map(async function (data) {
                    self.equipment_type_codes.push(data.code);
                    let newArr = {};
                    newArr.name = data.name;
                    newArr.code = data.code;
                    var newArrTemp = JSON.parse(JSON.stringify(newArr));
                    var newArrTemp2 = JSON.parse(JSON.stringify(newArr));
                    if(typeof self.$route.params.originalData === 'undefined'){
                        self.citySearch_equipment_types.push(newArrTemp);
                    }else {
                        self.citySearch_equipment_types.push(newArrTemp);
                    }
                    await self.mapSearch_equipment_types.push(newArrTemp2);
                });
                if(typeof self.$route.params.originalData === 'undefined'){
                    self.citySearch_equipment_type_id_list.push(config.ANYStr);
                }
                self.mapSearch_equipment_type_id_list.push(config.ANYStr);
            })
            .catch(err => {
                self._showToast(err.message, config.errMsgColorStr);
            });
        },
        formatDate(date) {
            let month = `${date.getMonth() + 1}`;
            let day = `${date.getDate()}`;
            const year = date.getFullYear();

            if (month.length < 2) month = `0${month}`;
            if (day.length < 2) day = `0${day}`;

            return [year, month, day].join('-');
        },
        changePickerDate(type) {
            const self = this;
            let evt = document.createEvent("HTMLEvents");
            evt.initEvent("input", false, true);
            setTimeout(function () {
                document.getElementById(type + '_date').dispatchEvent(evt);
            }, 10)
        },
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        _formatCitySearchForm() {
            const _dt = Object.assign({}, this.form.citySearch),
                _tmpDt = Object.assign({}, this.form.citySearch);
            const discardFields = {
                'origin_lat': true,
                'origin_lng': true,
                'origin_city': true,
                'origin_address': true,
                'origin_state': true,
                'dest_address': true,
                'picker_available_date': true,
                'selected_dest': true,
                'quantity': true,
                'user_uuid': true
            };
            if (this.form.citySearch.origin_radius === 'ANY' || !this.form.citySearch.origin_radius) {
                discardFields.origin_radius = true;
            }
            if (this.form.citySearch.dest_radius === 'ANY' || !this.form.citySearch.dest_radius) {
                discardFields.dest_radius = true;
            }
            let strParams = '';
            for (var key in _dt) {
                if (_dt.hasOwnProperty(key)) {
                    if (discardFields[key] || _dt[key] === false) {
                        delete _dt[key];
                    } else {
                        if (key == 'equipment_type_id') {
                            if (this.citySearch_equipment_type_id_list[0].code != config.ANYStr && this.citySearch_equipment_type_id_list[0] != config.ANYStr) {
                                _dt[key] = this.citySearch_equipment_type_id_list.join(',');
                            } else {
                                delete _dt[key];
                                continue;
                            }
                        }
                        const val = typeof _dt[key] === 'object' ? JSON.stringify(_dt[key]) : _dt[key];
                        strParams = !strParams ? key + '=' + val : strParams + '&' + key + '=' + val;
                    }
                }
            }
            if (_tmpDt.origin_lat && _tmpDt.origin_lng) {
                const orgCity = JSON.stringify([{
                    'lat': _tmpDt.origin_lat.toString(),
                    'lng': _tmpDt.origin_lng.toString(),
                    'origin_city': _tmpDt.origin_city ? _tmpDt.origin_city : ''
                }]);
                strParams = !strParams ? 'origin_city=' + orgCity : strParams + '&origin_city=' + orgCity;
            }
            return strParams;
        },
        _formatMapSearchForm() {
            const _dt = Object.assign({}, this.form.mapSearch),
                _tmpDt = Object.assign({}, this.form.mapSearch);
            const discardFields = {
                'origin_address': true,
                'destination_cities': true,
                'origin_city': true,
                'origin_lat': true,
                'origin_lng': true,
                'origin_state': true,
                'dest_states': true,
            };
            if (this.form.mapSearch.origin_radius === 'ANY' || !this.form.mapSearch.origin_radius) {
                discardFields.origin_radius = true;
            }
            let strParams = '';
            for (var key in _dt) {
                if (_dt.hasOwnProperty(key)) {
                    if (discardFields[key] || (_dt[key] === false)) {
                        delete _dt[key];
                    } else {
                        if (key == 'destination_cities' && !_dt[key].length) {
                            continue;
                        }
                        if (key == 'equipment_type_id') {
                            if (this.mapSearch_equipment_type_id_list[0].code != config.ANYStr && this.mapSearch_equipment_type_id_list[0] != config.ANYStr) {
                                _dt[key] = this.mapSearch_equipment_type_id_list.join(',');
                            } else {
                                delete _dt[key];
                                continue;
                            }
                        }
                        const val = typeof _dt[key] === 'object' ? JSON.stringify(_dt[key]) : _dt[key];
                        strParams = !strParams ? key + '=' + val : strParams + '&' + key + '=' + val;
                    }
                }
            }

            if (_tmpDt.origin_lat && _tmpDt.origin_lng) {
                const orgCity = JSON.stringify([{
                    'lat': _tmpDt.origin_lat.toString(),
                    'lng': _tmpDt.origin_lng.toString(),
                    'origin_city': _tmpDt.origin_city ? _tmpDt.origin_city : ''
                }]);
                strParams = !strParams ? 'origin_city=' + orgCity : strParams + '&origin_city=' + orgCity;
            }
            if (_tmpDt.destination_cities.length > 0) {
                strParams = !strParams ? 'dest_states=' + _tmpDt.destination_cities.toString() : strParams + '&dest_states=' + _tmpDt.destination_cities.toString();
            }
            return strParams;
        },
        clearCitySearchAddressBar() {
            this.form.citySearch.origin_lat = '';
            this.form.citySearch.origin_lng = '';
            this.form.citySearch.origin_city = '';
            this.form.citySearch.origin_state = '';
            this.hidden_city_origin_address = '';
        },
        onEquipmentChange(formType,data) {
            const self = this;
            if(data != ''){
                let selectedEquipmentCode = data.toString().split(',');
                self[formType+'_equipment_type_id_list'] = [];
                if(selectedEquipmentCode[(selectedEquipmentCode.length -1)]==config.ANYStr){
                    self[formType+'_equipment_type_id_list'].push(config.ANYStr);
                }else{
                    selectedEquipmentCode.map(async function (equipmentCode) {
                        if(equipmentCode != config.ANYStr){
                            await self[formType+'_equipment_type_id_list'].push(equipmentCode);
                        }        
                    });
                }
            }
        },
        onOriginRadiusChange(data) {
            this.form.citySearch.origin_radius = data.target.value;
        },
        onDestRadiusChange(data) {
            this.form.citySearch.dest_radius = data.target.value;
        },
        onMapRadiusChange(data) {
            this.form.mapSearch.origin_radius = data.target.value;
        },
        onClickFilterResults() {
            this.MapRadiusChange = true;
        },
    },
    data() {
        return {
            totalRecords:0,
            searchType:config.cityStr,
            currDate: new Date(),
            clientUserAgent: config.clientUserAgent,
            mapSearchScrollToOffset:config.mapSearchScrollToOffset,
            anywhereStr:config.anywhereStr,
            ANYStr:config.ANYStr,
            showSugg: "d-flex",
            showSearchFormMob: true,
            usSelectedStates: [],
            emptyStates: [],
            bothStatesObj: [],
            bothStates: API.bothStates,
            usSvgObj: API.usSvgObj,
            canadaSvgObj: API.canadaSvgObj,
            color: Material,
            permissionName: null,
            showAdvanceCityFields: false,
            form: {
                mapSearch: {
                    origin_address: '',
                    origin_city: '',
                    origin_lat: '',
                    origin_lng: '',
                    destination_cities: [],
                    origin_radius: 50,
                    available_date: new Date().toISOString().substr(0, 10),
                    picker_available_date: '',
                    load_size: '',
                    dest_states: '',
                    equipment_type_id: '',
                },
                citySearch: {
                    origin_address: '',
                    origin_city: '',
                    origin_lat: '',
                    origin_lng: '',
                    destination_cities: [],
                    dest_address: '',
                    dest_city: '',
                    dest_lat: '',
                    dest_lng: '',
                    equipment_type_id: '',
                    origin_radius: 50,
                    dest_radius: 50,
                    selected_dest: {},
                    available_date: new Date().toISOString().substr(0, 10),
                    picker_available_date: '',
                    load_size: '',
                    quantity: '1',
                    user_uuid: 'all',
                    max_age: '',
                    weight: '',
                    length: '',
                    height: ''
                }
            },
            equipment_types: [],
            citySearch_equipment_type_id_list: [],
            citySearch_equipment_name:'',
            newLoadSizeForMobile: '',
            mapSearch_equipment_type_id_list: [],
            hidden_map_origin_address: '',
            hidden_map_dest_city_count: 0,
            hidden_city_origin_address: '',
            hidden_city_dest_address: '',
            origin_map_state_code: '',
            citySearch_equipment_types: [],
            mapSearch_equipment_types: [],
            equipment_type_codes:[],
            trucks: {
                savedSearchTrucks: [],
                cityTrucks: [],
                mapTrucks: []
            },
            brokers: [{
                name: 'All',
                id: 'all'
            }],
            truck_size_arr: [{
                name: 'ANY',
                id: ''
            }, {
                name: 'LTL',
                id: 'LTL'
            }, {
                name: 'FULL',
                id: 'FULL'
            }],
            quantities: [{
                    name: '1',
                    id: 1
                }, {
                    name: '2',
                    id: 2
                }, {
                    name: '3',
                    id: 3
                }, {
                    name: '4',
                    id: 4
                },
                {
                    name: '5',
                    id: 5
                }, {
                    name: '6',
                    id: 6
                }, {
                    name: '7',
                    id: 7
                }, {
                    name: '8',
                    id: 8
                }, {
                    name: '9',
                    id: 9
                },
                {
                    name: '10',
                    id: 10
                }, {
                    name: '10+',
                    id: 11
                }
            ],
            max_age_arr: [{
                    name: '1 min',
                    id: 1
                }, {
                    name: '5 min',
                    id: 5
                }, {
                    name: '10 min',
                    id: 10
                }, {
                    name: '30 min',
                    id: 30
                },
                {
                    name: '45 min',
                    id: 45
                }, {
                    name: '1 hour',
                    id: 60
                }, {
                    name: '5 hour',
                    id: 300
                }, {
                    name: '8 hour+',
                    id: 480
                }
            ],
            selectedTab: 0,
            breadcrumbs: [{
                    name: 'Dashboard',
                    to: "/dashboard",
                    disabled: false
                },
                {
                    name: 'Broker/Shipper',
                    disabled: true
                },
                {
                    name: 'Truck Search',
                    to: "/trucks/search",
                    disabled: false
                },
            ],
        }
    }
};

Array.prototype.sortBy = function (p, type, valType) {
    return this.sort(function (a, b) {
        if (a[p] && b[p]) {
            var val1, val2;
            if (valType === 'num') {
                val1 = parseFloat(a[p]);
                val2 = parseFloat(b[p]);
                return type == 'asc' ? val1 - val2 : val2 - val1;
            } else {
                val1 = a[p].toString().toLowerCase();
                val2 = b[p].toString().toLowerCase();

                if (type == 'asc') {
                    return (val1 > val2) ? 1 : (val1 < val2) ? -1 : 0;
                } else {
                    return (val2 > val1) ? 1 : (val2 < val1) ? -1 : 0;
                }
            }
        }
    });
}
</script>

<style lang="stylus">
.v-datatable.v-table {
    .v-chip.v-chip--label {
        margin: 4px 4px 4px 16px
    }
}
#us-info-box,
#both-us-info-box,
#canada-info-box,
#both-canada-info-box {
    display: none;
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 1;
    background-color: #ffffff;
    border: 2px solid #BF0A30;
    border-radius: 5px;
    padding: 5px;
    font-family: arial;
}
</style>



// WEBPACK FOOTER //
// src/pages/trucks/SearchTrucks.vue